import axios from "axios";
import axiosRetry from "axios-retry";
import { getCookie } from "cookies-next";
import { PRELIMINARY_APPRAISAL_COOKIE_NAME } from "features/vehicleDetails/providers/partExchangeQuestions/usePartExchangeQuestions";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";

export type LookupVehicleCapDataParams = {
    Vrm: string;
    Mileage: number;
};

export type LookupVehicleCapDataResponse = {
    VRM: string;
    Mileage: number;
    Make: string;
    Range: string;
    Trim: string;
    BodyStyle: string;
    FuelType: string;
    FirstRegisteredDate: string;
    Colour: string;
    Transmission: string;
    EngineSize: number;
    BuildYear: number;
    ValuationImageUri: string;
    NeedToMakeAChangeContent: {
        [key: string]: any;
    };
};

export type LookupVehicleCapDataError = { Message: string };

export interface PreliminaryAppraisal {
    PartExchange: PartExchange;
}

export interface PartExchange {
    Valuation: number;
    ValuationRange: ValuationRange;
    VehicleRegistration: string;
    Mileage: number;
    Make: string;
    Model: string;
    Trim: string;
    Colour: string;
    Equity: number;
    ExpiryDate: string;
    ValuationImageUri: string;
}

export interface ValuationRange {
    MaximumValuation: number;
    MaximumValuationPercentage: number;
    MinimumValuation: number;
    MinimumValuationPercentage: number;
}

export const lookupVehicleCapData = async (data: LookupVehicleCapDataParams) => {
    const response = await axios.post<LookupVehicleCapDataResponse | LookupVehicleCapDataError>(
        process.env.NEXT_PUBLIC_LOOKUP_VEHICLE_CAP_DATA_ENDPOINT,
        data
    );

    axiosOnSuccessEvent(response);

    return response;
};

export const getPreliminaryAppraisal = async (
    cookie?: string
): Promise<PreliminaryAppraisal | undefined> => {
    if (
        process.env.NODE_ENV === "development" &&
        window.location.hostname === "localhost" &&
        getCookie(PRELIMINARY_APPRAISAL_COOKIE_NAME)
    ) {
        return {
            PartExchange: {
                Valuation: 9818.24,
                ValuationRange: {
                    MaximumValuation: 10309.15,
                    MaximumValuationPercentage: 5.0,
                    MinimumValuation: 9229.15,
                    MinimumValuationPercentage: 6.0,
                },
                Equity: 9818.24,
                VehicleRegistration: "YG63OPC",
                Mileage: 27500,
                ExpiryDate: "\/Date(1752101999000)\/",
                Make: "MG",
                Model: "3 EXCLUSIVE",
                Trim: "1150KW EXCLUSIVE EV 61KWH 5DR AUTO",
                Colour: "REDISH",
                ValuationImageUri:
                    "https://images.motorpoint.co.uk/capimages/noncommercial/98203/600-145f013235674813baab09e98085d035.jpg",
            },
        };
    }

    try {
        axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

        const response = await axios.get<PreliminaryAppraisal>(
            process.env.NEXT_PUBLIC_CURRENT_PART_EXCHANGE_ENPOINT,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    Accept: "/",
                },
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {}
};

export const partExchangeDeleteCookies = async (): Promise<any> => {
    try {
        const response = await axios.post<any>(
            `${process.env.NEXT_PUBLIC_PART_EXCHANGE_DELETE_COOKIE}?ShowPersonalDetails=True&ShowSaveAndContinue=True`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "/",
                    "Cache-Control": "no-cache",
                },
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {}
};
